// extracted by mini-css-extract-plugin
export default {"root":"AuditButton_root__TtLNF","text":"AuditButton_text__xIm40"};